import { Provider } from '@angular/core';
import { TICKET_CLIENT_REPOSITORY } from './application/ticket-client.tokens';
import { HttpTicketClientRepository } from './infrastructure/http/http-ticket-client.repository';
import { GetTicketClientDetailUseCase } from './application/get-ticket-client-detail.usecase';
import { RegisterTicketClientUseCase } from './application/register-ticket-client.usecase';
import { UpdateTicketClientFieldUseCase } from './application/update-ticket-client-field.usecase';
import { ListTicketsByConstitutionUseCase } from './application/list-tickets-by-constitution.usecase';

export const TICKET_CLIENT_PROVIDERS: Provider[] = [
  { provide: TICKET_CLIENT_REPOSITORY, useClass: HttpTicketClientRepository },
  GetTicketClientDetailUseCase,
  RegisterTicketClientUseCase,
  UpdateTicketClientFieldUseCase,
  ListTicketsByConstitutionUseCase,
];
